<template>
  <v-layout wrap>
    <!-- Top Banner -->
    <v-flex xs12>
      <div class="top-gray">
        <div class="left">
          <img
            src=""
            width="319"
            alt="EAGLE CASE ASSIGNMENT"
          />
        </div>
      </div>
    </v-flex>

    <!--Header -->
    <v-flex xs12>
      <div class="blue-bar">
        <h1
          class="appendYearVol"
        >EAGLE CASE ASSIGNMENT:</h1>
      </div>
    </v-flex>

    <!-- Main Contents -->
    <v-flex xs12>
      <v-layout class="bg-light-blue" wrap>
        <!-- LEFT: Introduction -->
        <v-flex xs1 />

        <!-- RIGHT: Sign In Box-->
        <v-flex xs1 />
        <v-flex xs9>
          <div class="sign-in-box">
            <v-form v-model="isFormValid" ref="form">
              <v-layout wrap>
                <v-flex xs12>
                  <div
                    class="label-blue"
                    style="text-align: left; margin-left: 460px;"
                  >Reset Password:</div>
                </v-flex>
                <v-flex class="logo-center" xs4>
                  <img src="" alt="EAGLE logo" width="100px" />
                </v-flex>
                <v-flex xs8>
                  <!-- <v-text-field solo class="log-in-fields" placeholder="Username" v-model="username" v-on:keyup.enter="login" /> -->
                  <!-- <v-text-field solo class="log-in-fields" placeholder="Old Password" v-model="oldPassword" :type="'password'" /> -->
                  <v-text-field
                    solo
                    class="log-in-fields"
                    placeholder="New Password"
                    v-model="newPassword"
                    :rules="rules"
                    :type="'password'"
										density="compact"
                  />
                  <v-text-field
                    solo
                    class="log-in-fields"
                    placeholder="Confirm Password"
                    v-model="confirmPassword"
                    :type="'password'"
                    :rules="[passwordConfirmationRule]"
                    v-on:keyup.enter="resetPassword"
										density="compact"
                  />
                  <v-layout>
                    <v-flex>
                      <!-- <v-btn normal :loading="isLoading" class="blue-button" @click="landing">Cancel</v-btn>&nbsp; -->
                      <v-btn
                        normal
                        :loading="isLoading"
                        :disabled=" !isFormValid || !confirmPassword"
                        class="blue-button"
                        @click="resetPassword"
                      >Submit</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-flex>
        <v-flex xs1 />

        <!-- BOTTOM: Orange bar-->
        <v-flex xs12>
          <div class="orange-bar">
            <h2>
              Please submit your survey response by
              <strong>July 10, 2020</strong>&nbsp;&nbsp;&nbsp;
              <span class="seperator">|</span>&nbsp;&nbsp;&nbsp;Your timely and accurate responses are very important.
            </h2>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>

    <!--Footer-->
    <v-layout class="footer">
      <v-layout>
        <v-flex xs1>
          <img
            class="footer-icon-left"
            width="50px"
            src=""
            alt="computer icon"
          />
        </v-flex>
        <v-flex xs4>
          <div class="footer-text-left">
            Technical Support
            <br />
            <a href="mailto:support@westat.com">support@westat.com</a>
            <br />(844) 592-6268&nbsp;&nbsp;|&nbsp;&nbsp;Help Desk Hours: 9 am – 5 pm, Mon-Fri ET
          </div>
        </v-flex>
        <v-flex xs1>
          <div class="footer-text-line">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img
              width="50px"
              src=""
              alt="pencil icon"
            />
            <br />
            <br />
          </div>
        </v-flex>
        <v-flex xs5>
          <div class="footer-text-middle">
            General Survey Questions
            <br />Christopher Pece, National Center for Science and Engineering Statistics, NSF
            <br />
            <a href="mailto:cpece@nsf.gov">cpece@nsf.gov</a>&nbsp;&nbsp;|&nbsp;&nbsp;(703) 292-7788
          </div>
        </v-flex>

        <v-flex xs2>
          <div class="footer-text-right">© 2020 National Science Foundation</div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import { authService } from '@/services/authService.js';
import router from '@/router';
import { authTokenService } from '@/services/authTokenService.js';
export default {
  name: 'resetpassword',
  data () {
    return {
      username: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      displayPassword: false,
      isLoading: false,
      show: false,
      isFormValid: false,
      rules: [
        v =>
          (v &&
            v.length >= 8 &&
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v)) ||
          'New password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, and one number'
      ]
    };
  },
  computed: {
    passwordConfirmationRule () {
      return () =>
        this.newPassword === this.confirmPassword ||
        'New passwords do not match';
    }
  },
  created () {
    var token = this.$route.query.token;
    console.log(token);
    if (token != null) {
      authTokenService.saveToken(token);
    }
  },
  methods: {
    login () {
      this.$data.isLoading = true;
      let me = this;
      authService
        .login(
          this.$data.userName,
          this.$data.oldPassword,
          this.$data.newPassword,
          this.$data.confirmPassword
        )
        .then(function (response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: 'landing' });
        })
        .catch(function (response) {
          console.log('Test handle error in component');
          me.$data.isLoading = false;
        });
    },
    changePassword () {
      this.$data.isLoading = true;
      let me = this;
      const claims = authTokenService.getClaims();
      authService
        .changePassword(
          claims.userName,
          this.$data.oldPassword,
          this.$data.newPassword,
          this.$data.confirmPassword
        )
        .then(function (response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: 'landing' });
        })
        .catch(function (response) {
          console.log('Test handle error in component');
          me.$data.isLoading = false;
        });
    },
    resetPassword () {
      this.$data.isLoading = true;
      let me = this;
      // const claims = authTokenService.getClaims();
      authService
        .resetPassword(this.$data.newPassword, this.$data.confirmPassword)
        .then(function (response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: 'landing' });
        })
        .catch(function (response) {
          console.log('Test handle error in component');
          me.$data.isLoading = false;
        });
    },
    landing () {
      router.push({ name: 'landing' });
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}
.login-container {
  border-radius: 5px;
  background-color: white;
  border: 1px solid #13314f;
}

.main-title {
  color: #313b52;
  font-family: Georgia, Times New Roman, Times, serif;
  font-size: 25px;
}
.sign-in-title-outer {
  padding-top: 60px;
}
.top-title-left-border {
  border-left: 1px solid #969696;
}
.sign-in-sub-title {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 21px;
  line-height: 40px;
  font-weight: bold;
  margin: 0 0 11px 0;
}
.sign-in-sub-title-right {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 40px;
  line-height: 59px;
  margin: 0 0 11px 0;
}
.blue-bar {
  background-color: #365f8d;
  padding: 6px 0;
}
.orange-bar {
  background-color: #cc7512;
  padding: 6px 0;
  margin-bottom: 15px;
}
.blue-title-text {
  font-family: Georgia, Times, Times New Roman, san-serif;
  color: #000000;
  font-size: 28px;
  font-weight: normal;
}
.blue-title-text a {
  color: #1b405a;
}
.bar-title {
  text-align: center;
}
.content-space {
  padding: 49px 23px;
  font-family: Arial, Helvetica, san-serif;
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.left {
  text-align: left;
  margin-left: 2%;
}
h1 {
  margin: 10px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-family: Calibri, Georgia, Time New Roman, Times, Serif;
  color: white;
  font-size: 30px;
  line-height: 40px;
  font-weight: normal;
  margin: 0 0 11px 0;
}
h2 {
  margin: 3px 0 !important;
  font-size: 20px;
  font-family: Calibri, Georgia, Times, Times New Roman, Serif !important;
  color: white;
}
.seperator {
  color: #d9e2f3;
}
.contents-pane {
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: -5%;
  background-color: #f2f7fa;
  padding: 3%;
  text-align: left;
  border-style: solid;
  border-width: 0px 0px 0px 15px;
  border-color: #365f8d;
  font-size: 11pt;
  color: black;
}
.sign-in-box {
  padding: 3% 3%;
  background-color: #ebf0f9;
  margin-top: 14%;
  border-style: solid;
  border-width: 1px;
  border-color: black;
  box-shadow: 2px 2px 3px 2px #b6b5b5;
  margin-left: -5%;
}
.logo-center {
  margin-top: 0%;
  margin-right: 0%;
  text-align: center;
}
.log-in-fields {
  margin-bottom: -15px;
  width: 275px;
}
.log-in-fields :deep(input) {
  text-align: left;
}
.indent {
  margin-left: 3%;
}
.margin-top {
  margin-top: 5px;
}
</style>
